import { BASE_URL } from "@constants/api.constants";
import { uploadImageFile } from "@utils/upload.util";

export const getManufacturerInputs = (initialValues) => [
  {
    type: "TEXT",
    label: "Manufacturer Name",
    id: "manufacturer_name",
    name: "manufacturer_name",
    value: initialValues?.manufacturer_name || "",
    placeholder: "Enter the Manufacturer Name",
    validations: [
      {
        type: "REQUIRED",
        message: "Manufacturer Name is required !",
      },
    ],
  },
  {
    type: "FILE_UPLOAD",
    label: "Profile Image",
    id: "profile_image",
    name: "profile_image",
    value: initialValues?.profile_image || "",
    filePrefix: BASE_URL + "app-source/images/",
    handleSelfUpload: uploadImageFile,
    validations: [],
  },
  {
    type: "SELECT",
    label: "Status",
    id: "status",
    name: "status",
    options: [
      { name: "Enable", value: "1" },
      { name: "Disable", value: "2" },
    ],
    value: initialValues?.status || "1",
    placeholder: "Select status",
  },
];
